<h1 mat-dialog-title>{{ 'properties.dialog.propertyTagNfcList.title' | translate }}</h1>

<mat-dialog-content class="mb-3">
  <div class="table-wrapper">
    <div class="table-toolbar">
      <div class="row align-items-center">
        <div class="col-12 col-sm-6 col-md-6">
        </div> <!-- /.col-12.col-md-4 -->
        <div class="col-12 col-sm-6 col-md-6 text-right">
          <button mat-button (click)="onExport()" class="d-none d-sm-inline-block">
            <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
            {{ 'common.words.export' | translate }}
          </button>
          <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
            <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
            {{ 'common.cta.resetFilters' | translate }}
          </button>
        </div> <!-- /.col-12.col-md-8 -->
      </div> <!-- /.row -->
    </div> <!-- /.table-toolbar -->
    <div class="spinner-container" *ngIf="dataSource.loading$ | async">
      <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
    </div> <!-- /.spinner-container -->
    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="name"
        matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
          <td mat-cell *matCellDef="let element; let i = index">
            {{ i + 1 }}
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="uid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
            {{ 'propertyTagNfc.fields.uid' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.uid }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field class="filter">
              <mat-label>{{ 'common.words.search' | translate }}</mat-label>
              <input matInput [formControl]="uidFilter">
              <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(uidFilter)"
                class="reset-input-icon" *ngIf="uidFilter.value"></mat-icon>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
            {{ 'propertyTagNfc.fields.name' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.name }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field class="filter">
              <mat-label>{{ 'common.words.search' | translate }}</mat-label>
              <input matInput [formControl]="nameFilter">
              <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(nameFilter)"
                class="reset-input-icon" *ngIf="nameFilter.value"></mat-icon>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="shortDescription">
          <th mat-header-cell *matHeaderCellDef class="col-fixed-md">
            {{ 'propertyTagNfc.fields.shortDescription' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.shortDescription">
              {{ 'propertyTagNfc.shortDescription.' + element.shortDescription | translate }}
            </span>
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field class="filter">
              <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                <mat-select [formControl]="shortDescriptionFilter">
                  <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                  <mat-option value="externalPushButtonPanel">{{ 'propertyTagNfc.shortDescription.externalPushButtonPanel' | translate }}</mat-option>
                  <mat-option value="understairsPushButtonPanel">{{ 'propertyTagNfc.shortDescription.understairsPushButtonPanel' | translate }}</mat-option>
                  <mat-option value="dedicatedLocalAccessDoor">{{ 'propertyTagNfc.shortDescription.dedicatedLocalAccessDoor' | translate }}</mat-option>
                  <mat-option value="driveway">{{ 'propertyTagNfc.shortDescription.driveway' | translate }}</mat-option>
                  <mat-option value="other">{{ 'propertyTagNfc.shortDescription.other' | translate }}</mat-option>
                </mat-select>
                <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(shortDescriptionFilter)"
                  class="reset-input-icon ml-n3" *ngIf="shortDescriptionFilter.value"></mat-icon>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
            {{ 'propertyTagNfc.fields.description' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.description }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field class="filter">
              <mat-label>{{ 'common.words.search' | translate }}</mat-label>
              <input matInput [formControl]="descriptionFilter">
              <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(descriptionFilter)"
                class="reset-input-icon" *ngIf="descriptionFilter.value"></mat-icon>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="latitude">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
            {{ 'propertyTagNfc.fields.latitude' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.latitude }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field class="filter">
              <mat-label>{{ 'common.words.search' | translate }}</mat-label>
              <input matInput [formControl]="latitudeFilter">
              <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(latitudeFilter)"
                class="reset-input-icon" *ngIf="latitudeFilter.value"></mat-icon>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="longitude">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
            {{ 'propertyTagNfc.fields.longitude' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.longitude }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field class="filter">
              <mat-label>{{ 'common.words.search' | translate }}</mat-label>
              <input matInput [formControl]="longitudeFilter">
              <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(longitudeFilter)"
                class="reset-input-icon" *ngIf="longitudeFilter.value"></mat-icon>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="installationDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
            {{ 'propertyTagNfc.fields.installationDate' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.installationDate | dateTimeFormat }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field class="filter">
              <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
              <input matInput [matDatepicker]="dpInstallationDate" (focus)="dpInstallationDate.open()" (click)="dpInstallationDate.open()" readonly
                placeholder="{{ 'common.cta.select' | translate }}" [formControl]="installationDateFilter"
                style="cursor: pointer" />
              <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                (click)="onResetFilter(installationDateFilter)" class="reset-input-icon"
                *ngIf="installationDateFilter.value"></mat-icon>
              <mat-datepicker-toggle matSuffix [for]="dpInstallationDate"></mat-datepicker-toggle>
              <mat-datepicker #dp></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="images">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
            {{ 'propertyTagNfc.fields.images' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.images">
              <ng-container *ngFor="let image of element.images; let i = index;">
                <a href="{{ configService.apiHost }}/{{ image.path }}" target="_blank" 
                  matTooltip="{{ 'common.words.clickToOpen' | translate }}" *ngIf="image.path">
                  [ {{ 'common.words.clickToOpen' | translate }} ]
                </a>
                <br>
              </ng-container>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field class="filter">
              <mat-label>{{ 'common.words.search' | translate }}</mat-label>
              <input matInput [formControl]="imagesFilter">
              <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(imagesFilter)"
                class="reset-input-icon" *ngIf="imagesFilter.value"></mat-icon>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="createdBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
            {{ 'propertyTagNfc.fields.createdBy' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.createdBy && element.createdBy.firstName !== ''">
              {{ element.createdBy.firstName }} {{ element.createdBy.lastName }}
            </span>
            <span *ngIf="!element.updatedBy">{{ 'common.words.dashes' | translate }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field class="filter">
              <mat-label>{{ 'common.words.search' | translate }}</mat-label>
              <input matInput [formControl]="createdByFilter">
              <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(createdByFilter)"
                class="reset-input-icon" *ngIf="createdByFilter.value"></mat-icon>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="updatedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
            {{ 'propertyTagNfc.fields.updatedBy' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.updatedBy && element.updatedBy.firstName !== ''">
              {{ element.updatedBy.firstName }} {{ element.updatedBy.lastName }}
            </span>
            <span *ngIf="!element.updatedBy">{{ 'common.words.dashes' | translate }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field class="filter">
              <mat-label>{{ 'common.words.search' | translate }}</mat-label>
              <input matInput [formControl]="updatedByFilter">
              <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(updatedByFilter)"
                class="reset-input-icon" *ngIf="updatedByFilter.value"></mat-icon>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
            {{ 'propertyTagNfc.fields.createdAt' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdAt | dateTimeFormat }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field class="filter">
              <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
              <input matInput [matDatepicker]="dpCreatedAt" (focus)="dpCreatedAt.open()" (click)="dpCreatedAt.open()" readonly
                placeholder="{{ 'common.cta.select' | translate }}" [formControl]="createdAtFilter"
                style="cursor: pointer" />
              <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                (click)="onResetFilter(createdAtFilter)" class="reset-input-icon"
                *ngIf="createdAtFilter.value"></mat-icon>
              <mat-datepicker-toggle matSuffix [for]="dpCreatedAt"></mat-datepicker-toggle>
              <mat-datepicker #dp></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="updatedAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
            {{ 'propertyTagNfc.fields.updatedAt' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.updatedAt | dateTimeFormat }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            <mat-form-field class="filter">
              <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
              <input matInput [matDatepicker]="dpUpdatedAt" (focus)="dpUpdatedAt.open()" (click)="dpUpdatedAt.open()" readonly
                placeholder="{{ 'common.cta.select' | translate }}" [formControl]="updatedAtFilter"
                style="cursor: pointer" />
              <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                (click)="onResetFilter(updatedAtFilter)" class="reset-input-icon"
                *ngIf="updatedAtFilter.value"></mat-icon>
              <mat-datepicker-toggle matSuffix [for]="dpUpdatedAt"></mat-datepicker-toggle>
              <mat-datepicker #dp></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
          [class.even-row]="(i % 2) == 0"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>
      <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
        showFirstLastButtons></mat-paginator>
    </div> <!-- /.table-responsive -->
  </div> <!-- /.table-wrapper -->
</mat-dialog-content>

<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-button (click)="onClose()" mat-raised-button mat-default
      class="ml-3">{{ 'common.cta.close' | translate }}</a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">

  </div> <!-- /.col -->
</div> <!-- /.row -->